<template>
  <Modal
    v-if="member && organisationAndMembers"
    class="organisation-member-removal-dialog text-left"
    v-model="shown"
    :title="
      'Remove ' + member.shortUserDetails.firstName + ' ' + member.shortUserDetails.lastName + '?'
    "
  >
    <div style="width: 100%">
      <p class="text-big">
        Are you sure you want to remove
        <b>{{ member.shortUserDetails.firstName }} {{ member.shortUserDetails.lastName }}</b> from
        <b>{{ organisationAndMembers.name }}</b
        >?
      </p>
      <p>
        <span class="text-warning">Note:</span> They will also be removed from any <b>Teams</b> and
        <b>Groups</b> in this organisation.
      </p>

      <p class="text-danger text-left" v-for="error in errors" v-bind:key="error">{{ error }}</p>
    </div>
    <template #footer>
      <div>
        <button class="btn btn-primary btn-lg" @click="doDelete()" type="button">Remove</button>

        <button class="btn btn-default btn-lg" @click="cancel()" type="button">Cancel</button>
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { ref } from "vue";
import axios from "axios";
import { Modal } from "uiv";

import { OrganisationAndMembersApiModel, OrganisationMemberApiModel } from "../../../api-models";

const resolveCallback = ref<((value: boolean) => void) | null>(null);
const rejectCallback = ref<((reason?: any) => void) | null>(null);

const errors = ref<string[]>([]);
const member = ref<OrganisationMemberApiModel | null>(null);
const organisationAndMembers = ref<OrganisationAndMembersApiModel | null>(null);
const shown = ref(false);
// @Component({ components: { Modal } })
// export default class OrganisationMemberRemovalDialog extends Vue {
//   resolveCallback: ((value: boolean) => void) | null = null;

//   rejectCallback: ((reason?: any) => void) | null = null;

//   errors: string[] = [];

//   member: OrganisationMemberApiModel | null = null;

//   organisationAndMembers: OrganisationAndMembersApiModel | null = null;

//   shown = false;

function close(): void {
  shown.value = false;
}

function cancel(): void {
  close();
  if (resolveCallback.value) {
    resolveCallback.value(false);
  }
}

function open(
  memberModel: OrganisationMemberApiModel,
  organisationAndMembersModel: OrganisationAndMembersApiModel,
): Promise<boolean> {
  member.value = memberModel;
  organisationAndMembers.value = organisationAndMembersModel;
  errors.value = [];
  shown.value = true;
  return new Promise((resolve, reject) => {
    resolveCallback.value = resolve;
    rejectCallback.value = reject;
  });
}

function doDelete(): void {
  axios
    .delete(`/api/organisationmember/${member.value?.shortUserDetails.id}`)
    .then((res) => {
      if (res.status !== 200) {
        errors.value = ["There was a problem removing the user, please try again."];
      } else {
        errors.value = [];
        close();
        if (resolveCallback.value) {
          resolveCallback.value(true);
        }
      }
    })
    .catch((error) => {
      errors.value = ["There was a problem removing the user, please try again."];
      if (error?.response?.data?.length) {
        errors.value.push(error.response.data);
      }
    });
}

defineExpose({ open, close });
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less"></style>
